import { Component, OnInit, AfterContentInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.css']
})
export class LogoutComponent implements OnInit, AfterContentInit {

  constructor(private router: Router) { }

  ngOnInit() {
  }

  ngAfterContentInit() {
    let cfm = confirm("Are you sure you want to log out?");

    if (cfm) {
      if (sessionStorage.getItem("token") !== null) {
        sessionStorage.clear();

        this.router.navigate(['login']);
      }
    } else {
      this.router.navigate(['home']);
    }
  }
}
